/**
 * PROinfra Shared API
 *
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


/**
 * Description value for a data entry. A many_to_one mapping is necessary to both AnalyticDescriptionType and AnalyticValue.
 */
export interface AnalyticDescription { 
    /**
     * Internal AnalyticDescription Key
     */
    id?: number;
    /**
     * Internal AnalyticValue Key
     */
    analyticValueId?: number;
    /**
     * Internal AnalyticDescriptionType Key
     */
    analyticDescriptionTypeId?: number;
    description?: string;
}

